import { render, staticRenderFns } from "./GoodsSettingCustomBadgeStyle.vue?vue&type=template&id=59799d56&scoped=true&"
import script from "./GoodsSettingCustomBadgeStyle.vue?vue&type=script&lang=js&"
export * from "./GoodsSettingCustomBadgeStyle.vue?vue&type=script&lang=js&"
import style0 from "./GoodsSettingCustomBadgeStyle.vue?vue&type=style&index=0&id=59799d56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59799d56",
  null
  
)

export default component.exports